'use client';

import React from 'react';

interface StatusBarProps {
  type: 'success' | 'error';
  message: string;
  onDismiss: () => void;
}

export function StatusBar({ type, message, onDismiss }: StatusBarProps) {
  const isSuccess = type === 'success';
  return (
    <div className={`flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium ${
      isSuccess ? 'bg-green-50 border border-green-200 text-green-800' : 'bg-red-50 border border-red-200 text-red-800'
    }`}>
      <span>{isSuccess ? '✓' : '⚠'}</span>
      <span className="flex-1">{message}</span>
      <button onClick={onDismiss} className="ml-2 opacity-60 hover:opacity-100 transition-opacity">✕</button>
    </div>
  );
}
